// 40週年彈簧床褥特許經銷商數據（來源：40週床褥特許經銷ver2 25.8.2026）
export const chainStores = {
  feicui: {
    name: '翡翠籐器有限公司',
    stores: [
      { branch: '灣仔店', address: '灣仔道181號長春大廈地下A號鋪連一樓', tel: '2866 6087' },
      { branch: '旺角店', address: '旺角洗衣街187號伊利莎大廈地下', tel: '2499 6759' },
      { branch: '上水店', address: '上水新成路69號地下', tel: '2398 0983' },
      { branch: '天水圍店', address: '天水圍嘉湖銀座二期2樓207舖', tel: '2944 2575' },
      { branch: '將軍澳店', address: '將軍澳唐明街將軍澳2號尚德邨尚德廣場二樓231A號鋪', tel: '2720 5178' }
    ]
  },
  aihuangbao: {
    name: '愛皇寶國際貿易公司',
    stores: [
      { branch: '深水埗店', address: '深水埗西邨路19號南昌薈F105舗', tel: '2631 3068' },
      { branch: '黃大仙店', address: '黃大仙竹園邨廣場1/F S105A鋪', tel: '3698 1649' },
      { branch: '官塘店', address: '官塘秀茂坪商場1樓111B', tel: '2191 0198' },
      { branch: '將軍澳店（彩明）', address: '將軍澳彩明商場210鋪', tel: '2386 4818' },
      { branch: '將軍澳店（千色百貨）', address: '將軍澳千色店百貨L2床品', tel: '3194 3890' },
      { branch: '將軍澳店（厚德）', address: '將軍澳厚德邨商場W126铺', tel: '2388 8005' }
    ]
  },
  tongbao: {
    name: '通寶行',
    stores: [
      { branch: '藍田店', address: '官塘藍田德田商場地下G3鋪', tel: '2709 1177' },
      { branch: '官塘店', address: '官塘翠屏北商場119-120號', tel: '2952 3382' }
    ]
  }
}

export const regionalStores = {
  hk: {
    name: '港島區',
    stores: [
      { name: '財華傢俬設計', address: '西環皇后大道西322號振坤樓地下', tel: '2559 5539' },
      { name: '摩登居室', address: '北角渣華道60號地下', tel: '2110 2252' },
      { name: '利豐傢俬公司', address: '香港仔大道88號地下B鋪', tel: '2555 0577' },
      { name: '威信傢俬公司', address: '香港仔大道212A鋪', tel: '2555 6348' }
    ]
  },
  kl: {
    name: '九龍區',
    stores: [
      { name: '昌盛傢俬', address: '深水埗青山道279號地下', tel: '2708 1084' },
      { name: '成興傢俬裝飾有限公司', address: '深水埗元洲街18號渭濱樓地下及2樓下', tel: '2361 6680' },
      { name: '強榮傢俬', address: '九龍長沙灣青山道444-450號康利大廈地下D鋪', tel: '2326 3528' },
      { name: '順興傢俬裝飾公司', address: '土瓜灣北帝街2號地下', tel: '2618 6498' },
      { name: '森源室內設計', address: '土瓜灣馬頭圍道234號地下', tel: '6187 7238' },
      { name: '瑋廸傢俬設計', address: '土瓜灣馬頭圍道302號地下', tel: '2768 4226' },
      { name: '金星傢俬', address: '新蒲崗爵祿街25號地下', tel: '2329 7393' },
      { name: '科雅室內設計', address: '官塘順安村安群樓地下7號鋪', tel: '6848 8238' },
      { name: '華軒傢俬', address: '觀塘道436-446號觀塘工業中心4期地下', tel: '3755 4372' },
      { name: '原木家居設計', address: '九龍彩雲邨第二期商場三樓A313鋪', tel: '2755 5138' },
      { name: '華藝傢俬公司', address: '九龍清水灣道彩雲一邨二期街市低層2號舖', tel: '2757 2556' }
    ]
  },
  nt: {
    name: '新界區',
    stores: [
      { name: '合宜傢俬中心', address: '葵涌石梨商場B319B號鋪', tel: '2401 0208' },
      { name: '益發傢俬', address: '葵涌和宜合道64號地下', tel: '2421 8772' },
      { name: '鴻利傢俬', address: '荃灣青山公路185號荃勝大廈1-2樓', tel: '2570 2698' },
      { name: '嘉豐設計有限公司', address: '荃灣街市街146號坤成樓地鋪', tel: '3598 2910' },
      { name: '長順傢俬公司', address: '青衣涌美邨1-2號地下', tel: '2497 8982' },
      { name: '家麗傢俬裝修設計公司', address: '屯門明藝街6-14號地下E鋪', tel: '2660 8686' },
      { name: '美適傢俬倉', address: '屯門震寰路9號好收成工業大廈地下', tel: '2462 3678' },
      { name: '永順傢俬公司', address: '屯門湖翠路138號啟豐商場1/F 48-49鋪', tel: '2459 1346' },
      { name: '新鸿發傢俬公司', address: '屯門青賢街2-10號雅都花園地下G23號舖', tel: '2452 3822' },
      { name: '永利傢具', address: '屯門良景邨商場L306B舖', tel: '2463 3083' },
      { name: '龍藝軒傢俬裝飾設計', address: '元朗大棠道48-56號一樓全層', tel: '2443 4228' },
      { name: '永利恒傢俬有限公司', address: '粉嶺聯和墟和豐街58號地下', tel: '2675 6242' },
      { name: '志利傢俬', address: '上水新成路22號地下', tel: '2639 7384' },
      { name: '長榮傢居設計有限公司', address: '大埔廣福道85號地鋪', tel: '2336 8488' }
    ]
  },
  macau: {
    name: '澳門',
    stores: [
      { name: '建輝傢俬', address: '澳門渡船街1號A-B地下', tel: '2836 8345 / 2833 6923' }
    ]
  }
}
